import { render, staticRenderFns } from "./modifyMatchStatusDialog.vue?vue&type=template&id=38db0a63&"
import script from "./modifyMatchStatusDialog.vue?vue&type=script&lang=js&"
export * from "./modifyMatchStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38db0a63')) {
      api.createRecord('38db0a63', component.options)
    } else {
      api.reload('38db0a63', component.options)
    }
    module.hot.accept("./modifyMatchStatusDialog.vue?vue&type=template&id=38db0a63&", function () {
      api.rerender('38db0a63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/clRealSendReceive/modifyMatchStatusDialog.vue"
export default component.exports